import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cf491a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between gap-2 items-center" }
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Tittel", -1))
const _hoisted_5 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_6 = { class: "flex gap-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-2xl" }, "Er du sikker?", -1))
const _hoisted_8 = { class: "font-bold italic" }
const _hoisted_9 = { class: "flex justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidationFormErrors = _resolveComponent("ValidationFormErrors")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_HcButton = _resolveComponent("HcButton")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
      class: "flex flex-col gap-4 category-form"
    }, [
      _createVNode(_component_ValidationFormErrors, {
        errors: _ctx.form.errors
      }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.category ? "Endre" : "Ny") + " kategori", 1),
        (_ctx.category)
          ? (_openBlock(), _createBlock(_component_HcButton, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDeleteModal = true)),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.showDeleteModal = true), ["enter"])),
              disabled: _ctx.form.processing,
              type: "button",
              class: "flex gap-1 items-center",
              color: "red"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  type: "mdi",
                  path: _ctx.deleteIcon
                }, null, 8, ["path"]),
                _createTextVNode(" Slett ")
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.title) = $event)),
          type: "text",
          id: "title",
          class: "form-input"
        }, null, 512), [
          [_vModelText, _ctx.form.title]
        ]),
        (_ctx.form.errors.title)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.form.errors.title), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_HcButton, {
          disabled: _ctx.form.processing,
          type: "submit",
          class: "flex gap-1 items-center",
          color: "green"
        }, {
          default: _withCtx(() => [
            (_ctx.form.processing)
              ? (_openBlock(), _createBlock(_component_SvgIcon, {
                  key: 0,
                  type: "mdi",
                  class: "animate-spin h-5 w-5",
                  path: _ctx.loadingIcon
                }, null, 8, ["path"]))
              : (_openBlock(), _createBlock(_component_SvgIcon, {
                  key: 1,
                  type: "mdi",
                  path: _ctx.saveIcon
                }, null, 8, ["path"])),
            _createTextVNode(" Lagre ")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_HcButton, {
          onClick: _ctx.cancelCreate,
          onKeyup: _withKeys(_ctx.cancelCreate, ["enter"]),
          disabled: !_ctx.form.isDirty || _ctx.form.processing,
          type: "button",
          class: "flex gap-1 items-center",
          color: "gray"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Tilbakestill ")
          ]),
          _: 1
        }, 8, ["onClick", "onKeyup", "disabled"])
      ])
    ], 32),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteCategory && _ctx.deleteCategory(...args)), ["prevent"])),
              class: "flex flex-col gap-2"
            }, [
              _hoisted_7,
              _createElementVNode("p", null, [
                _createTextVNode(" Er du sikker på at du vil slette kategorien "),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.category?.title), 1),
                _createTextVNode(" ? ")
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_HcButton, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDeleteModal = false)),
                  onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.showDeleteModal = false), ["enter"])),
                  color: "gray"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Avbryt ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_HcButton, {
                  color: "red",
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Slett")
                  ]),
                  _: 1
                })
              ])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}